import React from 'react'
import { withAuthorization } from '../session';
import JuntaItem from './juntaItem';
import Loader from 'react-loader-spinner';
import Modal from 'react-modal';
import modalStyle from '../styles/modal'
import EmptyList from '../useful/EmptyList';
import JuntaForm from './juntaForm';

Modal.setAppElement('#root');
class Junta extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            itemToEdit: null,
            juntas: [],
            types: [],
            type: '',
            locations: [],
            location: '',
            listings: [],
            listing: '',
            error: {
                isShow: false,
                message: ''
            }
        }
    }

    componentDidMount() {
        this.setState({ loading: true });
        this.listenData();
    }

    componentWillUnmount() {
        this.props.firebase.juntas().off();
    }

    listenData = () => {
        this.props.firebase.juntas().off();
        this.props.firebase.juntas().on('value', (snapshot) => {
            const dataObject = snapshot.val();
            let list = [];
            if (dataObject) {
                list = Object.keys(dataObject).map(key => ({
                    ...dataObject[key],
                    uid: key,
                }));
            }

            // categories
            let types = list.filter(item => item.type);
            types = types.map((item, i) => {
                return item.type;
            });
            types = [...new Set(types)];
            types.sort();

            let type = this.state.type;
            if (this.state.type === '' && types.length > 0) {
                type = types[0];
            }

            // locality
            let locations = list.filter(item => item.location);
            locations = locations.map((item, i) => {
                return item.location;
            });
            locations = [...new Set(locations)];
            locations.sort();

            let location = this.state.location;
            // if (this.state.location === '' && locations.length > 0) {
            //     location = locations[0];
            // }

            // listings
            let listings = list.filter(item => item.listing);
            listings = listings.map((item, i) => {
                return item.listing;
            });
            listings = [...new Set(listings)];
            listings.sort();

            let listing = this.state.listing;
            // if (this.state.listing === '' && listings.length > 0) {
            //     listing = listings[0];
            // }

            this.setState({
                juntas: list,
                types: types,
                type: type,
                locations: locations,
                location: location,
                listings: listings,
                listing: listing,
                loading: false,
            });

        });
    }

    handleUploadFile = (fileUrl, item) => {
        this.props.firebase.junta(item.uid)
            .set({
                title: item.title,
                type: item.type,
                location: item.location,
                listing: item.listing,
                fileUrl: fileUrl,
            })
            .then(() => {
                // do nothing
            })
            .catch(error => {
                this.showErrorModal("Los sentimos, ocurrió un error al subir el archivo.");
            });
    }

    handleSubmit = (uid, type, title, location, listing) => {

        if (!uid) {
            this.props.firebase.juntas().push({
                title: title,
                type: type,
                location: location,
                listing: listing
            }).then(() => {
                // do nothing
            }).catch(error => {
                this.showErrorModal("Los sentimos, no se pudo crear este elemento.");
                console.log(error);
            });
        } else {
            this.props.firebase.junta(uid)
                .update({
                    title: title,
                    type: type || '',
                    location: location || '',
                    listing: listing || '',

                })
                .then(() => {
                    // do nothing
                })
                .catch(error => {
                    this.showErrorModal("Los sentimos, no se pudo actualizar este elemento.");
                    console.log(error);
                });
        }

        this.setState({
            itemToEdit: null
        })
    }

    handleDelete = (item) => {
        const itemUid = item.uid;

        this.props.firebase.junta(itemUid).remove()
            .then(() => {
                // do nothing
            })
            .catch(error => {
                this.showErrorModal("Los sentimos, no se pudo eliminar este elemento.");
                console.log(error);
            });
    }

    handleEdit = (item) => {
        this.setState({
            itemToEdit: item
        });
        window.scrollTo({
            top: 0, behavior: 'smooth',
        })
    }

    showErrorModal = (message) => {
        this.setState({
            error: {
                isShow: true,
                message: message
            }
        });
    }

    closeErrorModal = () => {
        this.setState({
            error: {
                isShow: false,
                message: ''
            }
        });
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    render() {
        const { itemToEdit, juntas, loading, types, type, locations, location, listings, listing, error } = this.state;
        const time = new Date().getTime();

        const juntasByTypeAndLocation = juntas.filter((item) => {
            return (item.type === type || (type === "-") || (type === '') || types.length === 0) &&
                (item.location === location || (location === "-") || (location === '') || locations.length === 0) &&
                (item.listing === listing || (listing === "-") || (listing === '') || listings.length === 0)
        });
        juntasByTypeAndLocation.sort((a, b) => {
            return a.title.localeCompare(b.title);
        });

        const juntaItems = juntasByTypeAndLocation.length > 0 ?
            juntasByTypeAndLocation.map((item, i) => {
                return (
                    <JuntaItem
                        key={item.uid + time}
                        item={item}
                        handleDelete={this.handleDelete}
                        handleUploadFile={this.handleUploadFile}
                        showErrorModal={this.showErrorModal}
                        handleEdit={this.handleEdit}
                    />
                )
            })
            :
            <tr>
                <td colSpan="10">
                    <EmptyList />
                </td>
            </tr>

        return (
            <div >
                <JuntaForm key={time} itemToEdit={itemToEdit} handleSubmit={this.handleSubmit} />

                <div>
                    <h5 className="mb-0">Juntas de Clasificación: listado de archivos</h5>

                    {(!loading) ?
                        <div key={type} className="table-responsive-md">
                            <div className="row nav justify-content-end font-weight-bold m-0">
                                <div className="col col-auto pb-2 pr-0 text-dark">
                                    <select value={type} onChange={this.handleChange} name="type" className="border-secondary text-dark form-control form-control-sm">
                                        <option value="-">Todas las categorias</option>
                                        {types.map((item, index) => {
                                            return <option key={index} value={item}>{item}</option>
                                        })}
                                    </select>
                                </div>
                                <div className="col col-auto pb-2 pr-0 text-dark">
                                    <select value={location} onChange={this.handleChange} name="location" className="border-secondary text-dark form-control form-control-sm">
                                        <option value="-">Todas las localidades</option>
                                        {locations.map((item, index) => {
                                            return <option key={index} value={item}>{item}</option>
                                        })}
                                    </select>
                                </div>
                                <div className="col col-auto pb-2 pr-0 text-dark">
                                    <select value={listing} onChange={this.handleChange} name="listing" className="border-secondary text-dark form-control form-control-sm">
                                        <option value="-">Todos los listados</option>
                                        {listings.map((item, index) => {
                                            return <option key={index} value={item}>{item}</option>
                                        })}
                                    </select>
                                </div>
                            </div>
                            <table className="table table-sm ">
                                <thead className="thead-dark">
                                    <tr>
                                        <th className="pr-2 pl-2" scope="col">Título</th>
                                        <th className="pr-2 pl-2 text-center" scope="col">Categoría</th>
                                        <th className="pr-2 pl-2 text-center" scope="col">Localidad</th>
                                        <th className="pr-2 pl-2 text-center" scope="col">Listado</th>
                                        <th className="pr-2 pl-2" scope="col">Archivo</th>
                                        <th className="pr-2 pl-2 text-right" scope="col">Opciones</th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: '0.9em' }}>
                                    {juntaItems}
                                </tbody>
                            </table>
                        </div>
                        :
                        <div className="nav justify-content-center row">
                            <Loader className="mt-4"
                                type="ThreeDots"
                                color="#263238"
                                height={60}
                                width={60}
                                timeout={0} />
                        </div>
                    }
                </div>

                <Modal
                    isOpen={error.isShow}
                    contentLabel="Modal Example"
                    style={modalStyle}
                    onRequestClose={this.closeErrorModal}>
                    <div className="" style={{ minWidth: '300px', maxWidth: '400px' }}>
                        <h5 className="card-title">Error</h5>
                        <p className="card-text text-break">{error.message}</p>

                        <div className="nav justify-content-end">
                            <button onClick={this.closeErrorModal} className="btn btn-sm btn-dark">Cerrar</button>
                        </div>
                    </div>

                </Modal>
            </div>
        );
    }

}

const condition = authUser => !!authUser;
export default withAuthorization(condition)(Junta);
